
import React from "react";
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, 
  Tooltip, ResponsiveContainer, Cell
} from "recharts";
import { GlassCard, GlassCardContent, GlassCardHeader, GlassCardTitle, GlassCardDescription } from "@/components/ui/glass-card";

export function DevicesByLocation() {
  // Define various shades of orange
  const orangeColors = {
    light: '#FFEDD5',   // Light Orange
    pale: '#FED7AA',    // Pale Orange
    medium: '#FDBA74',  // Medium Orange
    primary: '#FB923C', // Primary Orange
    dark: '#F97316',    // Dark Orange
    deeper: '#EA580C',  // Deeper Orange
  };
  
  // Mock data for locations with our orange color palette
  const data = [
    { name: "Cupertino HQ", devices: 32, color: orangeColors.deeper },
    { name: "New York Office", devices: 14, color: orangeColors.dark },
    { name: "Remote", devices: 8, color: orangeColors.primary },
    { name: "London Office", devices: 11, color: orangeColors.medium },
    { name: "Tokyo Office", devices: 6, color: orangeColors.pale },
  ];

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 shadow-md rounded-md border border-gray-100">
          <p className="font-medium text-sm font-poppins">{`${label}`}</p>
          <p className="text-sm font-poppins">{`Devices: ${payload[0].value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <GlassCard variant="default">
      <GlassCardHeader className="pb-2">
        <GlassCardTitle className="text-lg font-medium">Devices by Location</GlassCardTitle>
        <GlassCardDescription>Geographic distribution of devices across global offices</GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent className="pt-0">
        <div className="h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 20, right: 10, left: 10, bottom: 40 }}
              barSize={35}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E0E0E0" vertical={false} />
              <XAxis 
                dataKey="name" 
                tick={{ fontFamily: 'Poppins, sans-serif', fontSize: 11, fill: "#333333" }}
                axisLine={{ stroke: '#E0E0E0' }}
                tickLine={false}
                angle={0}
                textAnchor="middle"
                interval={0}
                height={45}
              />
              <YAxis 
                tick={{ fontFamily: 'Poppins, sans-serif', fontSize: 11, fill: "#333333" }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />
              <Bar 
                dataKey="devices" 
                name="Devices" 
                radius={[4, 4, 0, 0]}
                animationDuration={1500}
              >
                {data.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={entry.color} 
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
